import { createContext } from 'react';
import { BusinessContextModel } from '../model/BusinessContext.model';

export const BusinessContext = createContext<BusinessContextModel | null>(null);
